// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M8SJl","footer":"styles_footer__ZnEeo","passCodeTooltip":"styles_passCodeTooltip__1xJ-8"};